import type { Blueprint } from '../blueprints/Blueprint';

export interface HasRepetitions extends Blueprint
{
    repeatable: boolean;
}

export const instanceOfHasRepetitions = (object: any): object is HasRepetitions =>
{
    return object && 'repeatable' in object;
};
